import React, { Component } from 'react';
import styles from './loading-wrapper.less';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import PropTypes from 'prop-types';
import i18n from '@i18next/i18n';

interface AddonLoadingProps {
    loadCover: boolean;
}

export default class AddonLoading extends Component<AddonLoadingProps> {
    public static propTypes = {
        loadCover: PropTypes.bool,
    };

    public render() {
        const { loadCover } = this.props;
        return (
            <div className={styles['loading-wrapper']}
                id={'addon-loading'}
                style={{
                    display: !loadCover ? 'none' : 'block',
                    // width: size.width, height: size.height,
                }}
            >
                <div className={styles['loading-content']}>
                    <div className={styles['loading-icon']}>
                        <div className={styles['loading-spin-circle']} style={{
                            width: browser.isMobile ? '80px' : '50px',
                            height: browser.isMobile ? '80px' : '50px',
                        }}/>
                    </div>
                    {
                        browser.isPc && <p className={styles['loading-text']} style={{
                            paddingTop: '10px',
                            fontSize: '12px',
                        }}>{i18n.t('内容加载中...')}</p>
                    }
                </div>
            </div>
        );
    }
}
